export class Templating
{

	public static getHTMLScriptContentObject(scriptIdObject:{[key:string]:string}):{[key:string]:string}
	{
		var result:{[key:string]:string} = {};
		for (var key in scriptIdObject)
		{
			result[key] = Templating.getHTMLScriptContent(scriptIdObject[key]);
		}
		return result;
	}

	public static getHTMLScriptContent(scriptId:string):string
	{
		return document.getElementById(scriptId).textContent;
	}

	public static renderDOMFromScript(scriptId:string, templateData:any):HTMLElement
	{
		return Templating.renderDOM(Templating.getHTMLScriptContent(scriptId), templateData);
	}

	public static renderStringFromScript(scriptId:string, templateData:any):string
	{
		return Templating.renderString(Templating.getHTMLScriptContent(scriptId), templateData);
	}

	public static renderString(templateString:string, templateData:any):string
	{
		var html = Templating.render(templateString, templateData);
		html = html.trim();
		return html;
	}

	public static renderDOM(templateString:string, templateData:any):HTMLElement
	{
		var dummy = document.createElement("div");
		var html = Templating.render(templateString, templateData);
		html = html.trim();
		dummy.innerHTML = html;

		return <HTMLElement>dummy.firstChild;
	}

	public static render(templateString:string, templateData:any)
	{

		var regExp = /\{\{(\w+|.)\}\}/g;

		var result = templateString.replace(regExp, function(match:string, p1:string) {

			if (p1 === ".")
			{
				return templateData;
			}

			var dataProperties = p1.split(".");

			var value = templateData;
			for (var i = 0; i < dataProperties.length; i++)
			{
				/** Remove long labels from submenus, and replace them with the size only (eg.: Window (6x3) -> (6x3)) */
				if (dataProperties[i] === "label")
				{
					const regExp = /\(([^)]+)\)/;
					if (value["label"])
					{
						const match = value["label"].match(regExp);
						if (match)
						{
							value = match[0];
							continue;
						}
					}
				}
				value = value[ dataProperties[i] ];
			}

			return value || "";
		});

		return result;
	}

	constructor()
	{

	}
}